if (!customElements.get('lookstan-fifth-pick')) {
  class LookstanFifthPick extends HTMLElement {
    static adding = false;
    connectedCallback() {
      this.onChange = event => {
        if (!event.target.matches('[data-fifth-option]')) return;
        event.stopPropagation();
        this.updateOptions(event.target.closest('[data-fifth-card]'), Number(event.target.dataset.fifthOption));
      };
      this.onClick = event => {
        const add = event.target.closest('[data-fifth-add]');
        if (add) { event.preventDefault(); event.stopPropagation(); this.add(add.closest('[data-fifth-card]')); }
        if (event.target.closest('[data-fifth-prev]')) this.move(-1);
        if (event.target.closest('[data-fifth-next]')) this.move(1);
      };
      this.addEventListener('change', this.onChange);
      this.addEventListener('click', this.onClick);
      if (this.querySelector('[data-fifth-card]')) this.requestKey = this.dataset.fifthSeed + ':' + this.dataset.cartSignature;
      this.querySelectorAll('[data-fifth-card]').forEach(card => this.updateOptions(card, -1));
      if (this.querySelector('[data-fifth-card]')) this.bindNavigation();
      else this.hidden = true;
      customElements.whenDefined('cart-offer-progress').then(() => {
        if (this.isConnected) customElements.get('cart-offer-progress').refresh();
      });
    }
    disconnectedCallback() { this.removeEventListener('change', this.onChange); this.removeEventListener('click', this.onClick); }
    update(count, seed, signature, results) {
      this.eligibleCount = count;
      if (count % 3 !== 2 || !seed) { this.hidden = true; this.requestKey = null; return; }
      const key = seed + ':' + signature;
      if (this.requestKey === key) return;
      this.requestKey = key;
      if (results) this.querySelector('[data-fifth-products]').innerHTML = results.innerHTML;
      this.querySelectorAll('[data-fifth-card]').forEach(card => this.updateOptions(card, -1));
      this.hidden = !this.querySelector('[data-fifth-card]');
      this.querySelector('[data-fifth-feedback]').textContent = '';
      if (!this.hidden) this.bindNavigation();
    }
    bindNavigation() {
      this.updateNavigation();
      this.querySelector('[data-fifth-products]').onscroll = () => this.updateNavigation();
    }
    variants(card) {
      if (!card.variants) card.variants = JSON.parse(card.querySelector('[data-fifth-variants]').textContent);
      return card.variants;
    }
    updateOptions(card, changedIndex) {
      const variants = this.variants(card);
      const selects = [...card.querySelectorAll('[data-fifth-option]')];
      selects.forEach((select,index) => {
        const prefix = selects.slice(0,index).map(item => item.value);
        for (const option of select.options) {
          if (!option.value) continue;
          option.disabled = !variants.some(variant => variant.options[index] === option.value && prefix.every((value,i) => !value || variant.options[i] === value));
        }
        if (index > changedIndex && select.selectedOptions[0]?.disabled) select.value = '';
      });
      const selected = selects.map(select => select.value);
      const match = variants.find(variant => selected.every((value,i) => value && variant.options[i] === value));
      card.selectedVariant = match || (selects.length === 0 ? variants[0] : null);
      card.querySelector('[data-fifth-add]').disabled = !card.selectedVariant || LookstanFifthPick.adding;
      const display = card.selectedVariant || variants.find(variant => selected.every((value,i) => !value || variant.options[i] === value));
      if (display) {
        card.querySelector('[data-fifth-price]').textContent = display.price;
        const image = card.querySelector('img');
        if (image && display.image) { image.removeAttribute('srcset'); image.src = display.image; }
      }
    }
    move(direction) {
      const list = this.querySelector('[data-fifth-products]');
      const card = list.querySelector('[data-fifth-card]');
      const rtl = getComputedStyle(this).direction === 'rtl';
      list.scrollBy({left: direction * (rtl ? -1 : 1) * (card.getBoundingClientRect().width + 12), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
    }
    updateNavigation() {
      const list = this.querySelector('[data-fifth-products]');
      const end = list.scrollWidth - list.clientWidth;
      this.querySelector('[data-fifth-prev]').disabled = Math.abs(list.scrollLeft) < 2;
      this.querySelector('[data-fifth-next]').disabled = Math.abs(list.scrollLeft) >= end - 2;
    }
    async add(card) {
      if (LookstanFifthPick.adding || !card.selectedVariant) return;
      LookstanFifthPick.adding = true;
      const variantId = card.selectedVariant.id;
      const button = card.querySelector('[data-fifth-add]');
      const feedback = this.querySelector('[data-fifth-feedback]');
      const root = window.Shopify?.routes?.root || '/';
      const fromDrawer = !!this.closest('cart-drawer');
      let added = false;
      let submitted = false;
      document.querySelectorAll('lookstan-fifth-pick [data-fifth-add],lookstan-fifth-pick select').forEach(element => element.disabled = true);
      button.textContent = this.dataset.addingLabel;
      feedback.textContent = '';
      try {
        const checkResponse = await fetch(root + '?sections=lookstan-offer-count', {cache:'no-store'});
        if (!checkResponse.ok) throw new Error(this.dataset.errorLabel);
        const checkData = await checkResponse.json();
        const check = new DOMParser().parseFromString(checkData['lookstan-offer-count'] || '', 'text/html').querySelector('[data-lookstan-offer-count]');
        if (!check) throw new Error(this.dataset.errorLabel);
        if (Number(check.textContent.trim()) % 3 !== 2) {
          feedback.textContent = this.dataset.changedLabel;
          customElements.get('cart-offer-progress').refresh();
          return;
        }
        const mainItems = document.getElementById('main-cart-items');
        const mainFooter = document.getElementById('main-cart-footer');
        const itemsSection = mainItems?.dataset.id || 'main-cart-items';
        const footerSection = mainFooter?.dataset.id || 'main-cart-footer';
        const sectionNames = [...new Set(['cart-drawer','cart-icon-bubble',itemsSection,footerSection])];
        submitted = true;
        const response = await fetch(this.dataset.addUrl, {method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:variantId,quantity:1}],sections:sectionNames,sections_url:location.pathname})});
        const data = await response.json();
        if (!response.ok || data.status) { submitted = false; throw new Error(data.description || this.dataset.errorLabel); }
        added = true;
        const drawer = document.querySelector('cart-drawer');
        if (fromDrawer && data.sections?.['cart-drawer'] && data.sections?.['cart-icon-bubble']) {
          drawer.classList.remove('is-empty');
          drawer.renderContents(data);
        }
        for (const [id,section,selector] of [['main-cart-items',itemsSection,'.js-contents'],['main-cart-footer',footerSection,'.js-contents'],['cart-icon-bubble','cart-icon-bubble','.shopify-section']]) {
          const target = document.getElementById(id);
          const html = data.sections?.[section];
          if (!target || !html) continue;
          const source = new DOMParser().parseFromString(html,'text/html').querySelector(selector);
          if (source) (target.querySelector(selector) || target).innerHTML = source.innerHTML;
        }
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') await publish(PUB_SUB_EVENTS.cartUpdate,{source:'lookstan-fifth-pick',productVariantId:variantId,cartData:data});
        document.querySelectorAll('lookstan-fifth-pick').forEach(element => { element.hidden = true; element.requestKey = null; });
        customElements.get('cart-offer-progress').refresh();
        if (fromDrawer) {
          const message = drawer?.querySelector('[data-offer-message]');
          if (message) { message.tabIndex = -1; message.focus({preventScroll:true}); }
        }
      } catch (error) {
        feedback.textContent = added ? this.dataset.addedLabel : submitted ? this.dataset.unconfirmedLabel : error.message || this.dataset.errorLabel;
        if (added || submitted) {
          this.requestKey = null;
          customElements.get('cart-offer-progress').refresh();
        }
      } finally {
        LookstanFifthPick.adding = false;
        if (this.isConnected) button.textContent = this.dataset.addLabel;
        document.querySelectorAll('lookstan-fifth-pick select').forEach(element => element.disabled = false);
        document.querySelectorAll('lookstan-fifth-pick').forEach(element => element.querySelectorAll('[data-fifth-card]').forEach(currentCard => element.updateOptions(currentCard,-1)));
      }
    }
  }
  customElements.define('lookstan-fifth-pick', LookstanFifthPick);
}
